import Q17 from './Q17';

export default Q17;
